export const GUARD_MODE_MORAL = 'moral'
export const GUARD_MODE_LEAVE = 'leave'

export function getGuardMode(env = process.env) {
  const mode = String(env?.VUE_APP_GUARD_MODE || '').trim().toLowerCase()
  return mode === GUARD_MODE_LEAVE ? GUARD_MODE_LEAVE : GUARD_MODE_MORAL
}

export function isGuardLeaveMode(env = process.env) {
  return getGuardMode(env) === GUARD_MODE_LEAVE
}

export function isGuardMoralMode(env = process.env) {
  return getGuardMode(env) === GUARD_MODE_MORAL
}

export function getGuardHomePath(env = process.env) {
  return isGuardLeaveMode(env) ? '/leave' : '/guard/moral'
}

export function getGuardNavSections(env = process.env) {
  if (isGuardLeaveMode(env)) {
    return [
      {
        label: '请假管理',
        branchDepth: 'short',
        items: [
          { name: '请假审批', path: '/leave', icon: 'leave', exact: true, matchPrefixes: ['/leave'] }
        ]
      }
    ]
  }

  return [
    {
      label: '德育管理',
      branchDepth: 'short',
      items: [
        { name: '门卫扣分', path: '/guard/moral', icon: 'star', exact: true },
        { name: '德育记录', path: '/guard/records', icon: 'chart', exact: true }
      ]
    }
  ]
}

